/**
 * 过滤器
 *
 * @date 2019-01-21
 * @author chenyongzheng
 */

import Vue from 'vue';
// 定制公交票类型
Vue.filter("ticketType",function(ticketId){
	switch (ticketId){
		case 1:
			return "月票"
			break;
		case 2:
			return "周票"
			break;	
		case 4:
			return "日票"
			break;	
		default:
			return "未知票类型"
			break;
	}
})
// 开票历史订单类型
Vue.filter("historyType",function(type){
	switch (type){
		case 1:
			return "包车发票"
			break;
		case 2:
			return "定制公交发票"
			break;	
		default:
			return "未知类型"
			break;
	}
})
// 开票历史开通状态
Vue.filter("historyStatus",function(status){
	switch (status){
		case 0:
			return "待开票"
			break;
		case 1:
			return "已开票"
			break;	
		default:
			return "未知类型"
			break;
	}
})
/**
 * 金额格式化
 *
 * @date 2019-01-21
 * @author chenyongzheng
 * @param val
 * @return {string}
 */
Vue.filter('cashFormat', function (number) {
		number = Number(number);
		return number.toFixed(2);
//     let decimals = 1;
//     let dec_point = '.';
//     let thousands_sep = ',';
// 
//     number = (number + '').replace(/[^0-9+-Ee.]/g, '');
//     let n = !isFinite(+number) ? 0 : +number,
//         prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
//         sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
//         dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
//         s = '',
//         toFixedFix = function (n, prec) {
//             let k = Math.pow(10, prec);
//             return '' + Math.ceil(n * k) / k;
//         };
// 
//     s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
//     let re = /(-?\d+)(\d{3})/;
//     while (re.test(s[0])) {
//         s[0] = s[0].replace(re, "$1" + sep + "$2");
//     }
// 
//     if ((s[1] || '').length < prec) {
//         s[1] = s[1] || '';
//         s[1] += new Array(prec - s[1].length + 1).join('0');
//     }
//     return s.join(dec);

})

Vue.filter('cashFormatT', function (number) {

    let decimals = 2;
    let dec_point = '.';
    let thousands_sep = ',';

    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    let n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            let k = Math.pow(10, prec);
            return '' + Math.ceil(n * k) / k;
        };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    let re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);

})

import moment from 'moment';

/**
 * 日期格式化
 *
 * @date 2019-01-21
 * @author chenyongzheng
 * @param val
 * @return {string}
 */
Vue.filter('dateMoment', function (val) {
    return moment(val).format('YYYY-MM-DD HH:mm');
})
Vue.filter('dateDay', function (val) {
    return moment(val).format('YYYY-MM-DD');
})
/**
 * 卡号格式化
 *
 * @date 2019-01-21
 * @author chenyongzheng
 * @param val
 * @return {string}
 */
Vue.filter('cardFormat', function (val) {
    try {
        return val.substring(0, 4) + '**** **** ****' + val.substring(16, 19);
    } catch (e) {

    }
})

/**
 * 手机号格式化
 *
 * @date 2019-01-21
 * @author chenyongzheng
 * @param val
 * @return {string}
 */
Vue.filter('phoneFormat', function (val) {
    try {
        return val.substring(0, 3) + '****' + val.substring(7, 11);
    } catch (e) {

    }
})

/**
 * 身份证号格式化
 *
 * @date 2019-01-21
 * @author chenyongzheng
 * @param val
 * @return {string}
 */
Vue.filter('idNumberFormat', function (val) {
    try {
        return val.substring(0, 4) + '**********' + val.substring(14, 18);
    } catch (e) {

    }
})
// 实时公交首末发车修改
Vue.filter('routeTime', function (val) {
    try {
        return val.split(":")[0]+":"+val.split(":")[1];
    } catch (e) {

    }
})


// WEBPACK FOOTER //
// ./src/assets/js/$filter.js